export default __webpack_public_path__ + "dad97da706bbb8a3ac50bff1a988e0d8.png";